import { useEffect, useState } from 'react';

export function DelayedRenderingComponent({
  children,
  onAllowContinue,
  delay = 1000,
}: {
  children: React.ReactNode;
  onAllowContinue?: () => void;
  delay?: number;
}) {
  const [isRendered, setIsRendered] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsRendered(true);
    }, delay);
    return () => clearTimeout(timer);
  }, [delay]);

  useEffect(() => {
    if (isRendered) {
      const timer = setTimeout(() => {
        onAllowContinue?.();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [isRendered, onAllowContinue]);

  return isRendered ? <>{children}</> : null;
}
